import { Component, Input, TemplateRef, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { CmSettingsService, PortalCoreFeature } from '@ats/cm/core';
import { Observable, Subject } from 'rxjs';

@Component({
    selector: 'cm-context-overlay',
    templateUrl: './context-overlay.component.html',
    styleUrls: ['./context-overlay.component.scss'],
    encapsulation: ViewEncapsulation.None,
    exportAs: 'cmOverlay',
    standalone: false
})
export class CmContextOverlayComponent {
	@Input() data: any;
	@Input() style: { [klass: string]: any };
	private closeSubj: Subject<void> = new Subject<void>();
	public close$: Observable<void> = this.closeSubj.asObservable();
	public contentTpl: TemplateRef<any>;
	public context: any;
	public titleTpl: TemplateRef<any>;
	public titleContext: any;
	@ViewChild('overlayTpl', { read: TemplateRef }) public template: TemplateRef<any>;
	@ViewChild('content', { read: ViewContainerRef }) vc: ViewContainerRef;
	readonly locFeature: PortalCoreFeature;

	constructor(private settings: CmSettingsService) {
		this.locFeature = this.settings.portalCoreFeature;
	}

	close() {
		this.closeSubj.next();
	}
}
